import { render, staticRenderFns } from "./JobDescriptionModal.vue?vue&type=template&id=a50b15a2&scoped=true&"
import script from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./JobDescriptionModal.vue?vue&type=script&lang=js&"
import style0 from "./JobDescriptionModal.vue?vue&type=style&index=0&id=a50b15a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50b15a2",
  null
  
)

export default component.exports